export const ATUALIZADO = 'Cliente atualizado'
export const CADASTRADO = 'Cliente adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados clientes cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há clientes com esse filtro'
